var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('OzOverlay',{class:[
    // Laying out the child container
    'flex',
    'items-center',
    'justify-center',
    // Can remove this once Oz page reset has been applied to all pages.
    'font-sans',
  ],attrs:{"should-fade-in":_vm.shouldFadeIn,"dark-mode":_vm.darkMode},on:{"scrim-click":_vm.scrimClick,"scrim-esc":_vm.scrimEsc}},[_c('div',{ref:"modalContainer",class:[
      // Margins
      'mt-0',
      // Layout
      'h-auto',
      'overflow-auto',
      'flex',
      'flex-col',
      'oz-modal-container-height',
      // Main container's colors and flairs
      'bg-transparent',
      'rounded-3xl',
      _vm.widthClass,
      _vm.shadowClass,
    ],style:({ minHeight: _vm.minRenderHeight })},[_c('div',{ref:"modalContainerInner",class:{
        // Colors for content
        'bg-light-ui-100 dark:bg-dark-ui-100': _vm.darkMode === 'auto',
        'bg-light-ui-100': _vm.darkMode === false,
        'bg-dark-ui-100': _vm.darkMode === true,
        // Layout wrt the main container
        'min-h-full': true,
        'flex-grow': true,
        'overflow-hidden': true,
        // Layout the children
        'flex-col': true,
        flex: true,
      }},[(_vm.$slots.header)?_c('header',[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{ref:"modalBody",staticClass:"h-auto flex flex-grow flex-col p-0 overflow-auto scrollbar-regular dark:scrollbar-regular-dark"},[_vm._t("body")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }